export class Question {
  public ConditionId?: number;
  public TypeRestrictionId?: number;
  public ValueString: string;
  public LoadValue: boolean;
  public PatientQuestion: string;
  public Value: string;
  public BlockAffirmation: boolean;
  public BlockNegation: boolean;
  public ReferenceValidation: boolean;
  public Reference: number;
  public LoadObservation: boolean;
  public Observation: string;
  public BlockMessage: string;
  public AnswerValue: any;
}
